import React, { useEffect, useState } from 'react';
import api from '../../../lib/api';
import { MessageCircle, ExternalLink } from 'lucide-react';

/**
 * WhatsApp group link shown as a button beside the batch header in every audit modal.
 * Pass `link`/`source` directly from row data, OR pass `batchId` to fetch it.
 */
export default function BatchWhatsappButton({ link, source, batchId, className = '' }) {
  const [resolved, setResolved] = useState({ link: link ?? null, source: source ?? '' });

  useEffect(() => {
    if (link !== undefined) { setResolved({ link: link || '', source: source || '' }); return; }
    if (!batchId) return;
    let alive = true;
    api.get(`/training/audit/batch-detail/${batchId}`)
      .then((r) => { if (alive) setResolved({ link: r.data?.batch?.whatsapp_link || '', source: r.data?.batch?.whatsapp_source || '' }); })
      .catch(() => { if (alive) setResolved({ link: '', source: '' }); });
    return () => { alive = false; };
  }, [link, source, batchId]);

  const waLink = (resolved.link || '').trim();

  if (!waLink) {
    return (
      <div className={`inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-[11px] font-medium text-slate-400 ${className}`} data-testid="batch-whatsapp-empty">
        <MessageCircle className="w-3.5 h-3.5" />No WhatsApp link
      </div>
    );
  }
  return (
    <a href={waLink} target="_blank" rel="noreferrer" data-testid="batch-whatsapp-link"
       className={`inline-flex items-center gap-1.5 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 transition-colors ${className}`}>
      <MessageCircle className="w-3.5 h-3.5" />Open WhatsApp group
      {resolved.source && <span className="px-1.5 py-0.5 rounded bg-emerald-100 text-[9px]">{resolved.source}</span>}
      <ExternalLink className="w-3 h-3" />
    </a>
  );
}
